import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ChangesModel } from 'projects/phdsoft/common/src/lib/models/changes.model';
import { IFilter } from 'src/app/filter/filter.component';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ChangesWorkflowService {
  changes: Record<string, ChangesModel> = {}

  private _regionId: string;
  public get regionId(): string {
    return this._regionId;
  }
  public set regionId(v: string) {
    this._regionId = v;
  }

  private _sectionId: string;
  public get sectionId(): string {
    return this._sectionId;
  }
  public set sectionId(v: string) {
    this._sectionId = v;
  }

  private _elementId: string;
  public get elementId(): string {
    return this._elementId;
  }
  public set elementId(v: string) {
    this._elementId = v;
  }

  private _assetId: string;
  public get assetId(): string {
    return this._assetId;
  }
  public set assetId(v: string) {
    this._assetId = v;
  }

  private _regionName: string;
  public get regionName(): string {
    return this._regionName;
  }
  public set regionName(v: string) {
    this._regionName = v;
  }

  private _sectionName: string;
  public get sectionName(): string {
    return this._sectionName;
  }
  public set sectionName(v: string) {
    this._sectionName = v;
  }


  constructor(
    private http: HttpClient
  ) { }

  getAllChanges(assetId: string){
    return this.http.get<ChangesModel[]>(
      environment.API_THREED + `Changes/GetAll/${assetId}`,
    )
  }

  addChange(change: ChangesModel){
    this.changes[change.fieldName] = change
  }

  removeChange(fieldName: string){
    delete this.changes[fieldName]
  }

  addJustification(fieldName:string, text:string){
    this.changes[fieldName].changeExplanation = text
  }

  saveChanges(){
    for(var key in this.changes){
      this.changes[key].assetId = this.assetId
      this.changes[key].regionId = this.regionId
      this.changes[key].sectionId = this.sectionId
      this.changes[key].elementId = this.elementId
      this.changes[key].regionName = this.regionName
      this.changes[key].sectionName = this.sectionName


      this.http.post(environment.API_THREED + `Changes`, this.changes[key]).subscribe(ret=>{
        console.log(ret)
        delete this.changes[key]
      })
    }
  }

  clearChanges(){
    this.changes = {}
  }

  /**
   * Detaches the pending changes, stamped with the current context fields
   * (asset/region/section/element), so they can be saved later — e.g. only
   * after a recompartment succeeded. Selecting another element meanwhile
   * (which clears or refills `changes`) no longer affects the detached set.
   */
  takePendingChanges(): ChangesModel[] {
    const pending: ChangesModel[] = Object.keys(this.changes).map(key => ({
      ...this.changes[key],
      assetId: this.assetId,
      regionId: this.regionId,
      sectionId: this.sectionId,
      elementId: this.elementId,
      regionName: this.regionName,
      sectionName: this.sectionName,
    }))
    this.changes = {}
    return pending
  }

  /** Posts changes detached with `takePendingChanges` (one request per change, like `saveChanges`). */
  savePendingChanges(pending: ChangesModel[]): void {
    for (const change of pending ?? []) {
      this.saveChange(change).subscribe({
        next: ret => console.log(ret),
        error: error => console.error('savePendingChanges: change log not saved', error),
      })
    }
  }

  saveChange(change:ChangesModel){
    return this.http.post(environment.API_THREED + `Changes`, change)
  }

  updateBaselineThicknessByCluster(cluster: IFilter) {
    var ret = this.http.post<ChangesModel[]>(environment.API_THREED + `Changes/UpdateBaselineThicknessByCluster`, cluster )
    return ret
  }

  deleteChange(id: string, assetId: string) {
    return this.http.delete(environment.API_THREED + `Changes?id=${id}&assetId=${assetId}`)
  }
}
